/**
 * File custom-video-button.js.
 *
 * Handles video play button for different blocks.
 */
(function ($) {
	'use strict';

	$(document).on('click', '.mdmodule_video__play', function () {
		var _this = $(this),
			videoId = _this.attr('data-id') || '',
			parentObj = _this.parents('.mdmodule_video__wrap');
		if ('' != videoId) {
			if (!parentObj.hasClass('active')) {
				parentObj.addClass('active');
				$('#' + videoId).trigger('play');
			} else {
				parentObj.removeClass('active');
				$('#' + videoId).trigger('pause');
			}
		}
		return false;
	});

})(jQuery);